var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "cloud_upload_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cloud_upload_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 12.215l-1.333 1.318a.692.692 0 01-.513.207.726.726 0 01-.531-.223.683.683 0 01-.212-.526.732.732 0 01.212-.527l2.494-2.495A.867.867 0 0112 9.698c.241 0 .452.09.633.271l2.494 2.495a.749.749 0 01.22.518.681.681 0 01-.22.536.715.715 0 01-.52.21.746.746 0 01-.534-.205l-1.323-1.308v5.477c0 .077.032.148.096.212a.294.294 0 00.212.096H18.5c.7 0 1.292-.242 1.775-.725.483-.483.725-1.075.725-1.775s-.242-1.292-.725-1.775C19.792 13.242 19.2 13 18.5 13H17v-2c0-1.383-.488-2.563-1.463-3.537C14.563 6.487 13.383 6 12 6s-2.563.487-3.537 1.463C7.488 8.437 7 9.617 7 11h-.52c-.947 0-1.764.342-2.45 1.025A3.364 3.364 0 003 14.5c0 .967.342 1.792 1.025 2.475A3.372 3.372 0 006.5 18h1.75c.213 0 .39.072.534.216A.726.726 0 019 18.75c0 .213-.072.391-.216.535a.726.726 0 01-.534.215H6.5c-1.382 0-2.56-.48-3.537-1.438-.975-.96-1.463-2.13-1.463-3.516 0-1.242.4-2.335 1.199-3.278.8-.943 1.79-1.501 2.974-1.676.32-1.495 1.072-2.717 2.255-3.667C9.111 4.975 10.468 4.5 12 4.5c1.81 0 3.347.63 4.608 1.892C17.869 7.653 18.5 9.189 18.5 11v.5h.308c1.054.082 1.932.506 2.636 1.271.704.766 1.056 1.675 1.056 2.729 0 1.115-.385 2.06-1.154 2.837-.77.775-1.711 1.163-2.827 1.163h-5.461c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 01-.525-1.283v-5.477z",
    fill: "#fff"
  }))));
}
export default SvgCloudUpload;